import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d25b3c18"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "QuestionTplEditorViewContainer"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft18"
}, "套题详情编辑", -1));
const _hoisted_3 = {
  key: 7,
  class: "mt16 wd100"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  const _component_LogicalQuestionEditor = _resolveComponent("LogicalQuestionEditor");
  const _component_Logical2DQuestionEditor = _resolveComponent("Logical2DQuestionEditor");
  const _component_TextLogicalReasoningQuestionEditor = _resolveComponent("TextLogicalReasoningQuestionEditor");
  const _component_OpticalPathQuestionEditor = _resolveComponent("OpticalPathQuestionEditor");
  const _component_Unfolding3DEditor = _resolveComponent("Unfolding3DEditor");
  const _component_SeesawQuestionEditor = _resolveComponent("SeesawQuestionEditor");
  const _component_PriceCalculateQuestionEditor = _resolveComponent("PriceCalculateQuestionEditor");
  const _component_QuestionReviewRenderPage = _resolveComponent("QuestionReviewRenderPage");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "flex items-center justify-center"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 12,
      class: "flex items-center"
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 12,
      class: "flex justify-end items-center"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.go(-1))
      }, {
        default: _withCtx(() => [_createTextVNode("返回")]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }), $data.subject && $data.subject == 'LogicalReasoning' ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "flex items-center justify-center wbg wd100 mt16 pd12"
  }, {
    default: _withCtx(() => [_createVNode(_component_LogicalQuestionEditor, {
      data: $data.tpl
    }, null, 8, ["data"])]),
    _: 1
  })) : $data.subject && $data.subject == 'LogicalReasoning2D' ? (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    class: "flex items-center justify-center wbg wd100 mt16 pd12"
  }, {
    default: _withCtx(() => [_createVNode(_component_Logical2DQuestionEditor, {
      data: $data.tpl
    }, null, 8, ["data"])]),
    _: 1
  })) : $data.subject && $data.subject == 'TextLogicalReasoning' ? (_openBlock(), _createBlock(_component_el_row, {
    key: 2,
    class: "flex items-center justify-center wbg wd100 mt16 pd12"
  }, {
    default: _withCtx(() => [_createVNode(_component_TextLogicalReasoningQuestionEditor, {
      data: $data.tpl
    }, null, 8, ["data"])]),
    _: 1
  })) : $data.subject && $data.subject == 'OpticalPathInference' ? (_openBlock(), _createBlock(_component_el_row, {
    key: 3,
    class: "flex items-center justify-center wbg wd100 mt16 pd12"
  }, {
    default: _withCtx(() => [_createVNode(_component_OpticalPathQuestionEditor, {
      data: $data.tpl
    }, null, 8, ["data"])]),
    _: 1
  })) : $data.subject && $data.subject == 'Unfolding3D' ? (_openBlock(), _createBlock(_component_el_row, {
    key: 4,
    class: "flex items-center justify-center wbg wd100 mt16 pd12"
  }, {
    default: _withCtx(() => [_createVNode(_component_Unfolding3DEditor, {
      data: $data.tpl
    }, null, 8, ["data"])]),
    _: 1
  })) : $data.subject && $data.subject == 'Seesaw' ? (_openBlock(), _createBlock(_component_el_row, {
    key: 5,
    class: "flex items-center justify-center wbg wd100 mt16 pd12"
  }, {
    default: _withCtx(() => [_createVNode(_component_SeesawQuestionEditor, {
      data: $data.tpl
    }, null, 8, ["data"])]),
    _: 1
  })) : $data.subject && $data.subject == 'PriceCalculate' ? (_openBlock(), _createBlock(_component_el_row, {
    key: 6,
    class: "flex items-center justify-center wbg wd100 mt16 pd12"
  }, {
    default: _withCtx(() => [_createVNode(_component_PriceCalculateQuestionEditor, {
      data: $data.tpl
    }, null, 8, ["data"])]),
    _: 1
  })) : $data.subject ? (_openBlock(), _createElementBlock("div", _hoisted_3, [$data.preview ? (_openBlock(), _createBlock(_component_QuestionReviewRenderPage, {
    key: 0,
    "edit-mode": true,
    onReGenerate: $options.reGenerate,
    "group-size": $options.ansTypeMap($data.subject),
    subject: $data.subject,
    data: $data.preview
  }, null, 8, ["onReGenerate", "group-size", "subject", "data"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
}